import { Typography } from '@mui/material';

/**
 * @typedef {Object} HeadingProps
 * @property {React.ReactNode} children - Heading content
 * @property {string} [variant] - Typography variant (default: 'h2')
 * @property {string} [component] - HTML element to render (default: matches variant)
 * @property {string} [className] - Additional CSS classes
 * @property {Object} [sx] - Additional Material-UI sx props
 * @property {string} [color] - Text color
 * @property {string} [align] - Text alignment
 */

/**
 * Heading component for consistent typography
 *
 * A reusable heading component that provides consistent typography,
 * spacing, and styling for page headings and titles.
 *
 * @param {HeadingProps} props - Component props
 * @returns {JSX.Element} Heading component
 */
function Heading({
  children,
  variant = 'h2',
  component,
  className,
  sx = {},
  color = 'text.primary',
  align = 'center',
}) {
  return (
    <Typography
      variant={variant}
      component={component || variant}
      className={className}
      color={color}
      align={align}
      sx={{
        mb: { xs: 2, md: 3 },
        fontWeight: 600,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export default Heading;
